import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/NalichnikiMateriali.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'

class NalichnikiMateriali extends React.Component {
  
  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { list, title, text } = this.props

    return (
      <section className={styles.section}>
        <Container>
          <div className={styles.card}>
            <div>
              <div className={styles.title} dangerouslySetInnerHTML={{__html: title}} />
              <div className={styles.text} dangerouslySetInnerHTML={{__html: text}} />
            </div>
            <div className={styles.card_rb}>
              {list.map( ( elm, k ) => {
                return (
                  <div key={k}>
                    <div className={styles.card_rb_name}>{elm?.name}</div>
                    <Image src={elm?.image} alt={elm?.name} width={142} height={50} />
                  </div>
                )
              })}
            </div>
          </div>
        </Container>
      </section>
    )
  }
}

NalichnikiMateriali.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string,
  text: PropTypes.string
}

NalichnikiMateriali.defaultProps = {
  list: [],
  title: ``,
  text: ``
}

export default NalichnikiMateriali